(() => {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.productID = this.getAttribute("data-product-id");
      this.productCount = this.querySelectorAll(".product-card").length;
    }

    async connectedCallback() {
      try {
        const response = await fetch(
          `${
            window.Shopify.routes.root
          }recommendations/products?product_id=${this.productID}&limit=${this.productCount}&section_id=product-recommendations`
        );
        const responseText = await response.text();
        if (!response.ok) {
          throw new Error("");
        }
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const targetProductCards = this.querySelectorAll(".product-card");
        const newProductCards = Array.from(
          html.querySelectorAll(".product-card")
        );

        targetProductCards.forEach((card, index) => {
          card.replaceWith(newProductCards[index]);
        });

        const lazyImages = document.querySelectorAll(".lazy__img");

        lazyImages.forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", () => {
              img.classList.remove("lazy__img--loading");
            });
          } else {
            img.classList.remove("lazy__img--loading");
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  if (!customElements.get("product-reccommendations")) {
    customElements.define("product-reccommendations", ProductRecommendations);
  }
})();
